import React, { useState, useRef } from 'react'
import { submitAnnexureTwo } from '../../../auth/services/privateapicalling';
import { toast } from 'react-toastify';

interface APMCp2Props {
  onNext: () => void;
  onBack: () => void;
   userDetail: any;
  couchID?: string;
  token: string;
  purpose?: any;
  applicationId?: string;
  formData: any;
  schemeIdd: string;
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement> , documentName: string) => void;
}

const APMCp2 = ({
  onNext,
  onBack,
  formData,
  userDetail,
  purpose,
  token,
  applicationId,
  couchID,
  handleFileChange,
  schemeIdd,
}: APMCp2Props) => {
//---------------------------------- Validation state----------------------------------
  


  
  // Validation logic for each field
  const validate = () => {
    const errors: { [key: string]: string } = {};
    if (!formData.permissionFromAuthority) errors.permissionFromAuthority = "Construction Approval is Required.";
    if (!formData.insuranceUndertakingPostConstruction) errors.insuranceUndertakingPostConstruction = "Insurance Undertaking is Required.";
    if (!formData.auditUndertakingAfterAssistance) errors.auditUndertakingAfterAssistance = "Audit Undertaking is Required.";
    if (!formData.schemeConditionsUndertaking) errors.schemeConditionsUndertaking = "Compliance Undertaking is Required.";
    if (!formData.jointAccountAssistanceUndertaking) errors.jointAccountAssistanceUndertaking = "Joint Account Undertaking is Required.";
    if (!formData.noPriorAssistanceUndertaking) errors.noPriorAssistanceUndertaking = "No Prior Assistance Undertaking is Required.";
    if (!formData.registerMaintenanceUndertaking) errors.registerMaintenanceUndertaking = "register Maintenance Undertaking is Required.";
    if (!formData.repaymentOnViolationUndertaking) errors.repaymentOnViolationUndertaking = "repayment On Violation Undertaking is Required.";
    if (!formData.constructionCompletionCertificate) errors.constructionCompletionCertificate = "construction Completion Certificate is Required.";
    if (!formData.noOutstandingDuesUndertaking) errors.noOutstandingDuesUndertaking = "no Outstanding Dues Undertaking is Required.";
    if (!formData.constructionProcurementETendering) errors.constructionProcurementETendering = "construction Procurement ETendering is Required.";
    if (!formData.goodsProcurementETendering) errors.goodsProcurementETendering = "goods Procurement ETendering is Required.";
    if (!formData.guaranteeAssistance) errors.guaranteeAssistance = "Guarantee Assistance is Required.";
    return errors;
  };

  // --- Refs for focusing on error fields ---
  const refs = {
    permissionFromAuthority: useRef<HTMLInputElement>(null),
    insuranceUndertakingPostConstruction: useRef<HTMLInputElement>(null),
    auditUndertakingAfterAssistance: useRef<HTMLInputElement>(null),
    schemeConditionsUndertaking: useRef<HTMLInputElement>(null),
    jointAccountAssistanceUndertaking: useRef<HTMLInputElement>(null),
    noPriorAssistanceUndertaking: useRef<HTMLInputElement>(null),
    registerMaintenanceUndertaking: useRef<HTMLInputElement>(null),
    repaymentOnViolationUndertaking: useRef<HTMLInputElement>(null),
    constructionCompletionCertificate: useRef<HTMLInputElement>(null),
    noOutstandingDuesUndertaking: useRef<HTMLInputElement>(null),
    constructionProcurementETendering: useRef<HTMLInputElement>(null),
    goodsProcurementETendering: useRef<HTMLInputElement>(null),
    guaranteeAssistance: useRef<HTMLInputElement>(null),
  };

   
const buildAnnexureTwoPayload = () => {
  return {
  
    permissionFromAuthority: {
      data: formData.permissionFromAuthority
        ? [{ docId: formData.permissionFromAuthority.docId, documentName: "permissionFromAuthority", fileName: formData?.permissionFromAuthority?.fileName }]
        : []
    },
    insuranceUndertakingPostConstruction: {
      data: formData.insuranceUndertakingPostConstruction
        ? [{ docId: formData.insuranceUndertakingPostConstruction.docId, documentName: "insuranceUndertakingPostConstruction", fileName: formData?.insuranceUndertakingPostConstruction?.fileName}]
        : []
    },
    auditUndertakingAfterAssistance: {
      data: formData.auditUndertakingAfterAssistance
        ? [{ docId: formData.auditUndertakingAfterAssistance.docId, documentName: "auditUndertakingAfterAssistance", fileName: formData?.auditUndertakingAfterAssistance?.fileName }]
        : []
    },
    schemeConditionsUndertaking: {
      data: formData.schemeConditionsUndertaking
        ? [{ docId: formData.schemeConditionsUndertaking.docId, documentName: "schemeConditionsUndertaking", fileName: formData?.schemeConditionsUndertaking?.fileName}]
        : []
    },
    jointAccountAssistanceUndertaking: {
      data: formData.jointAccountAssistanceUndertaking
        ? [{ docId: formData.jointAccountAssistanceUndertaking.docId, documentName: "jointAccountAssistanceUndertaking", fileName: formData?.jointAccountAssistanceUndertaking?.fileName }]
        : []
    },
    noPriorAssistanceUndertaking: {
      data: formData.noPriorAssistanceUndertaking
        ? [{ docId: formData.noPriorAssistanceUndertaking.docId, documentName: "noPriorAssistanceUndertaking", fileName: formData?.noPriorAssistanceUndertaking?.fileName }]
        : []
    },
    registerMaintenanceUndertaking: {
      data: formData.registerMaintenanceUndertaking
        ? [{ docId: formData.registerMaintenanceUndertaking.docId, documentName: "registerMaintenanceUndertaking", fileName: formData?.registerMaintenanceUndertaking?.fileName }]
        : []
    },
    repaymentOnViolationUndertaking: {
      data: formData.repaymentOnViolationUndertaking
        ? [{ docId: formData.repaymentOnViolationUndertaking.docId, documentName: "repaymentOnViolationUndertaking", fileName: formData?.repaymentOnViolationUndertaking?.fileName}]
        : []
    },
    constructionCompletionCertificate: {
      data: formData.constructionCompletionCertificate
        ? [{ docId: formData.constructionCompletionCertificate.docId, documentName: "constructionCompletionCertificate", fileName: formData?.constructionCompletionCertificate?.fileName }]
        : []
    },
    noOutstandingDuesUndertaking: {
      data: formData.noOutstandingDuesUndertaking
        ? [{ docId: formData.noOutstandingDuesUndertaking.docId, documentName: "noOutstandingDuesUndertaking", fileName: formData?.noOutstandingDuesUndertaking?.fileName }]
        : []
    },
    constructionProcurementETendering: {
      data: formData.constructionProcurementETendering
        ? [{ docId: formData.constructionProcurementETendering.docId, documentName: "constructionProcurementETendering", fileName: formData?.constructionProcurementETendering?.fileName}]
        : []
    },
    goodsProcurementETendering: {
      data: formData.goodsProcurementETendering
        ? [{ docId: formData.goodsProcurementETendering.docId, documentName: "goodsProcurementETendering", fileName: formData?.goodsProcurementETendering?.fileName }]
        : []
    },
    guaranteeAssistance: {
      data: formData.guaranteeAssistance
        ? [{ docId: formData.guaranteeAssistance.docId, documentName: "guaranteeAssistance", fileName: formData?.guaranteeAssistance?.fileName }]
        : []
    }
  };
};
  const errors = validate();
//----------------------------------Next Click----------------------------------
  const handleNextClick = async() => {
    try {
      if (Object.keys(errors).length !== 0) {
        // Focus the first error field
        const firstErrorKey = Object.keys(errors)[0];
        if (firstErrorKey && refs[firstErrorKey] && refs[firstErrorKey].current) {
          refs[firstErrorKey].current.focus();
        }
        return;
      }
      const formdata = {
        schemeId: String(schemeIdd),
        departmentId: userDetail?.Department_ID,
        districtId: userDetail?.Department?.district_id,
        couchId: couchID,
        annexureTwo: buildAnnexureTwoPayload(),
      };
      const res = await submitAnnexureTwo(formdata, token, applicationId);
    
      if (res?.success) {
        toast.success(res?.message || " Form submitted successfully",{position:"top-right"})
        onNext();
      } else {
        toast.error(res?.message || "Failed to submit Annexure Two",{position:"top-right"});
      }
    } catch (error) {
     
    }
  };

  return (
    <>
      <div className="page-wrapper">
         
            <div  className='d-flex flex-column text-nightblue align-items-center justify-content-center  '>
              <div id='table' className='w-100 border bg-white border-secondary rounded mb-5'>
                <div id='head' className='d-flex w-100  rounded-top border-bottom border-secondary' style={{backgroundColor:"#CCE3FF"}}>
                    <h4 className='col-1 p-2 justify-content-center d-flex align-items-center'>S.No.</h4>
                    <h4 className='col-6 p-2 justify-content-center d-flex align-items-center border-start border-end border-secondary '>પ્રશ્ન(Field)</h4>
                    <h4 className='col-5 p-2 justify-content-center d-flex align-items-center'>જવાબ(Response)</h4>
                   
                </div>
                <div className='d-flex border-bottom border-secondary'>
                        <h4 className='col-1 d-flex align-items-center justify-content-center '>11.</h4>
                        <p className='col-11 border-start border-secondary p-2'>નીચે મુજબની બાંહેધરીઓ / પ્રમાણપત્રો (Following undertakings/certificates to be submitted:)</p>
                       
                </div>
 
                <div className='d-flex border-bottom border-secondary '>
                    <h4 className='col-1'></h4>
                    <div className='d-flex gap-2 border-start border-end border-secondary '>
                        <h4 className='col-1 d-flex align-items-center justify-content-center border-end border-secondary'>01.</h4>
                        <p className='w-100 p-2 '>બજાર સમિતિમાં બાંધકામ કરવા માટે સંબંધિત સક્ષમ સત્તાધિકારીની મેળવેલ મંજૂરીની નકલ અથવા સક્ષમ સત્તાધિકારીની મંજૂરી મેળવી બાંધકામ કરવામાં આવશે તેવી લેખિત બાંહેધરી સામેલ છે ? તેની નકલ (Permission copy from competent authority or written undertaking to obtain permission).*</p>
                    </div>
                    <div className='col-5 d-flex flex-column d-flex align-items-center justify-content-center'>
                        <input type="file" className="form-control w-75"  onChange={(e)=>handleFileChange(e,"permissionFromAuthority")} name="permissionFromAuthority"   accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" id="uploadPlan" ref={refs.permissionFromAuthority} />
                      { formData?.permissionFromAuthority&&<p className="small text-success">Uploaded :{formData?.permissionFromAuthority?.fileName }</p>}
                   
                {errors && errors.permissionFromAuthority && (
                          <span className="text-danger small">{errors.permissionFromAuthority}</span>
                        )}
                    </div>
                </div>
 
                <div className='d-flex border-bottom border-secondary '>
                    <h4 className='col-1'></h4>
                    <div className='d-flex gap-2 border-start border-end border-secondary '>
                        <h4 className='col-1 d-flex align-items-center justify-content-center border-end border-secondary'>02.</h4>
                        <p className='w-100 p-2'>સહાય મેળવ્યા બાદ કરેલ બાંધકામનો વીમો લેવામાં આવશે, તેવી સંબંધિત બજાર સમિતિની લેખિત બાંહેધરીસામેલ છે ? તેની નકલ (Written undertaking that insurance will be taken after construction).* </p>
                    </div>
                    <div className='col-5 d-flex flex-column d-flex align-items-center justify-content-center'>
                        <input type="file" className="form-control w-75" onChange={(e)=>handleFileChange(e,"insuranceUndertakingPostConstruction")} name="insuranceUndertakingPostConstruction"   accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" id="uploadPlan" ref={refs.insuranceUndertakingPostConstruction} />
                       { formData?.insuranceUndertakingPostConstruction&& <p className="small text-success">Uploaded :{formData?.insuranceUndertakingPostConstruction?.fileName }</p>}
                {errors && errors.insuranceUndertakingPostConstruction && (
                          <span className="text-danger small">{errors.insuranceUndertakingPostConstruction}</span>
                        )}
                    </div>
                </div>
 
                <div className='d-flex border-bottom border-secondary '>
                    <h4 className='col-1'></h4>
                    <div className='d-flex gap-2 border-start border-end border-secondary '>
                        <h4 className='col-1 d-flex align-items-center justify-content-center border-end border-secondary'>03.</h4>
                        <p className='w-100 p-2'>સહાય મેળવ્યા બાદ હિસાબોનું ઓડીટ સહકારી ખાતાના ઓડીટર મારફતે કરાવવામાં આવશે, તેવી સંબંધિત બજાર સમિતિની લેખિત બાંહેધરીસામેલ છે ? તેની નકલ (Written undertaking for accounts audit by Co-operative Department Auditor after receiving assistance).*</p>
                    </div>
                    <div className='col-5 d-flex flex-column d-flex align-items-center justify-content-center'>
                        <input type="file" className="form-control w-75" onChange={(e)=>handleFileChange(e,"auditUndertakingAfterAssistance")} name="auditUndertakingAfterAssistance"   accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" id="uploadPlan" ref={refs.auditUndertakingAfterAssistance} />
                        { formData?.auditUndertakingAfterAssistance&&<p className="small text-success">Uploaded :{formData?.auditUndertakingAfterAssistance?.fileName }</p>}
                {errors && errors.auditUndertakingAfterAssistance && (
                          <span className="text-danger small">{errors.auditUndertakingAfterAssistance}</span>
                        )}
                    </div>
                </div>
 
                <div className='d-flex border-bottom border-secondary '>
                    <h4 className='col-1'></h4>
                    <div className='d-flex gap-2 border-start border-end border-secondary '>
                        <h4 className='col-1 d-flex align-items-center justify-content-center border-end border-secondary'>04.</h4>
                        <p className='w-100 p-2'>આયોજનાની તમામ શરતોનું પાલન કરવામાં આવશે, તેવી લેખિત બાંહેધરીસામેલ છે ? તેની નકલ (Written undertaking to follow all scheme conditions).*</p>
                    </div>
                    <div className='col-5 d-flex flex-column d-flex align-items-center justify-content-center'>
                        <input type="file" className="form-control w-75" onChange={(e)=>handleFileChange(e,"schemeConditionsUndertaking")} name="schemeConditionsUndertaking"   accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" id="uploadPlan" ref={refs.schemeConditionsUndertaking} />
                       { formData?.schemeConditionsUndertaking&&<p className="small text-success">Uploaded :{formData?.schemeConditionsUndertaking?.fileName }</p>}
                {errors && errors.schemeConditionsUndertaking && (
                          <span className="text-danger small">{errors.schemeConditionsUndertaking}</span>
                        )}
                    </div>
                </div>

                <div className='d-flex border-bottom border-secondary '>
                    <h4 className='col-1'></h4>
                    <div className='d-flex gap-2 border-start border-end border-secondary '>
                        <h4 className='col-1 d-flex align-items-center justify-content-center border-end border-secondary'>05.</h4>
                        <p className='w-100 p-2'>મંજુર થયેલ સહાયની રકમ બજાર સમિતિ અને જે તે જિલ્લાના નાયબ નિયામક ખેત બજાર અને ગ્રામ્ય અર્થતંત્ર અને જિલ્લા રજિસ્ટ્રાર, સ.મં,ના સંયુક્ત નામે રાષ્ટ્રિયકૃત બેન્કમાં જમા કરવામાં આવશે અને વપરાશના પ્રમાણમાં જિલ્લા, રજિસ્ટ્રારશ્રીની મંજૂરીથી સહાયનો ઉપાડ કરવામાં આવશે, તેવી લેખિત બાંહેધરી, સામેલ છે ? તેની નકલ (Undertaking that assistance amount will be deposited in a joint account of APMC and relevant authorities in a nationalized bank and withdrawal will be based on usage approval).*</p>
                    </div>
                    <div className='col-5 d-flex flex-column align-items-center justify-content-center'>
                        <input type="file" className="form-control w-75" onChange={(e)=>handleFileChange(e,"jointAccountAssistanceUndertaking")} name="jointAccountAssistanceUndertaking"   accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" id="uploadPlan" ref={refs.jointAccountAssistanceUndertaking} />
                     { formData?.jointAccountAssistanceUndertaking&&<p className="small text-success">Uploaded :{formData?.jointAccountAssistanceUndertaking?.fileName }</p>}
                {errors && errors.jointAccountAssistanceUndertaking && (
                          <span className="text-danger small">{errors.jointAccountAssistanceUndertaking}</span>
                        )}
                    </div>
                </div>
 
                <div className='d-flex border-bottom border-secondary '>
                    <h4 className='col-1'></h4>
                    <div className='d-flex gap-2 border-start border-end border-secondary '>
                        <h4 className='col-1 d-flex align-items-center justify-content-center border-end border-secondary'>06.</h4>
                        <p className='w-100 p-2'>જે હેતુ માટે સહાયની માંગણી કરવામાં આવી છે તે હેતુ માટે આ અગાઉ સરકારશ્રી કે અન્ય સહાય આપતી  નાણાંકીય સંસ્થા પાસેથી સહાયની રકમ મેળવવામાં આવેલ નથી તેમજ ભવિષ્યમાં મેળવીશુ નહી તેવી લેખિત બાંહેધરી સામેલ છે ?તેની નકલ (Written undertaking that no prior assistance has been obtained from government or financial institutions for the same purpose).*</p>
                    </div>
                    <div className='col-5 d-flex flex-column d-flex align-items-center justify-content-center'>
                        <input type="file" className="form-control w-75" onChange={(e)=>handleFileChange(e,"noPriorAssistanceUndertaking")} name="noPriorAssistanceUndertaking"   accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" id="uploadPlan" ref={refs.noPriorAssistanceUndertaking} />
                        { formData?.noPriorAssistanceUndertaking&&<p className="small text-success">Uploaded :{formData?.noPriorAssistanceUndertaking?.fileName }</p>}
                {errors && errors.noPriorAssistanceUndertaking && (
                          <span className="text-danger small">{errors.noPriorAssistanceUndertaking}</span>
                        )}
                    </div>
                </div>
 
                <div className='d-flex border-bottom border-secondary '>
                    <h4 className='col-1'></h4>
                    <div className='d-flex gap-2 border-start border-end border-secondary '>
                        <h4 className='col-1 d-flex align-items-center justify-content-center border-end border-secondary'>07.</h4>
                        <p className='w-100 p-2'>નિયામકશ્રી, ખેત બજાર અને ગ્રામ્ય અર્થતંત્ર, ગાંધીનગર સુચવે તે પ્રકારના રજિસ્ટરો નિભાવવાના રહેશે અને જરૂર જણાય તેવી માહિતી જ્યારે માંગે ત્યારે પુરી પાડવાની રહેશે, તે અંગેની લેખિત બાંહેધરી સામેલ છે ? તેની નકલ (Undertaking to maintain prescribed registers and provide information as and when requested by the Director, Agricultural Market & Rural Economy).*</p>
                    </div>
                    <div className='col-5 d-flex flex-column d-flex align-items-center justify-content-center'>
                        <input type="file" className="form-control w-75" onChange={(e)=>handleFileChange(e,"registerMaintenanceUndertaking")} name="registerMaintenanceUndertaking"   accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" id="uploadPlan" ref={refs.registerMaintenanceUndertaking} />
                       { formData?.registerMaintenanceUndertaking&&<p className="small text-success">Uploaded :{formData?.registerMaintenanceUndertaking?.fileName }</p>}
                {errors && errors.registerMaintenanceUndertaking && (
                          <span className="text-danger small">{errors.registerMaintenanceUndertaking}</span>
                        )}
                    </div>
                </div>
 
                <div className='d-flex border-bottom border-secondary '>
                    <h4 className='col-1'></h4>
                    <div className='d-flex gap-2 border-start border-end border-secondary '>
                        <h4 className='col-1 d-flex align-items-center justify-content-center border-end border-secondary'>08.</h4>
                        <p className='w-100 p-2'>આ યોજનાની કોઇપણ શરતનોભંગ થયેલ જણાયેથી સહાયની રકમ વ્યાજ સહિત પરત લેવા સરકારશ્રી હકકદાર રહેશે, તે અંગેની લેખિત બાંહેધરી. સામેલ છે ? તેની નકલ (Undertaking to repay assistance with interest if any condition of the scheme is violated).*</p>
                    </div>
                    <div className='col-5 d-flex flex-column d-flex align-items-center justify-content-center'>
                       
                <input type="file" className="form-control w-75" onChange={(e) => handleFileChange(e, "repaymentOnViolationUndertaking")} name="repaymentOnViolationUndertaking" accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" id="uploadPlan" ref={refs.repaymentOnViolationUndertaking} />
                     { formData?.repaymentOnViolationUndertaking&&<p className="small text-success">Uploaded :{formData?.repaymentOnViolationUndertaking?.fileName }</p>}
                {errors && errors.repaymentOnViolationUndertaking && (
                          <span className="text-danger small">{errors.repaymentOnViolationUndertaking}</span>
                        )}
                    </div>
                </div>
 
                <div className='d-flex border-bottom border-secondary '>
                    <h4 className='col-1'></h4>
                    <div className='d-flex gap-2 border-start border-end border-secondary '>
                        <h4 className='col-1 d-flex align-items-center justify-content-center border-end border-secondary'>09.</h4>
                        <p className='w-100 p-2'>બજાર સમિતિએ વિકાસના કામ માટે સહાય મળ્યા બાદ બે વર્ષની અંદર પૂરા કરવાના રહેશે, તે અંગે તથા સહાયની રકમ વપરાશ કર્યા અંગેનું માન્ય પેનલ પરના એન્જીનીયરની સહી સાથે રજૂ કરવામાં આવશે, તે અંગેની લેખિત બાંહેધરી સામેલ છે ? તેની નકલ. (Construction must be completed within 2 years after receiving assistance certificate signed by panel engineer to be submitted).*</p>
                    </div>
                    <div className='col-5 d-flex flex-column d-flex align-items-center justify-content-center'>
                        <input type="file" className="form-control w-75" onChange={(e)=>handleFileChange(e,"constructionCompletionCertificate")} name="constructionCompletionCertificate"  accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" id="uploadPlan" ref={refs.constructionCompletionCertificate} />
                        { formData?.constructionCompletionCertificate&&<p className="small text-success">Uploaded :{formData?.constructionCompletionCertificate?.fileName }</p>}
                {errors && errors.constructionCompletionCertificate && (
                          <span className="text-danger small">{errors.constructionCompletionCertificate}</span>
                        )}
                    </div>
                </div>
 
                <div className='d-flex border-bottom border-secondary '>
                    <h4 className='col-1'></h4>
                    <div className='d-flex gap-2 border-start border-end border-secondary '>
                        <h4 className='col-1 d-flex align-items-center justify-content-center border-end border-secondary'>10.</h4>
                        <p className='w-100 p-2'>બજાર સમિતિ પાસે સરકારશ્રીનું કે કોઇ સંસ્થાનું મુદતવીતી લેણું બાકી નથી, તેવી લેખિત બાંહેધરી. સામેલ છે ? તેની નકલ (Undertaking that APMC has no outstanding government or institutional dues).*</p>
                    </div>
                    <div className='col-5 d-flex flex-column d-flex align-items-center justify-content-center'>
                        <input type="file" className="form-control w-75" onChange={(e)=>handleFileChange(e,"noOutstandingDuesUndertaking")} name="noOutstandingDuesUndertaking"  accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" id="uploadPlan" ref={refs.noOutstandingDuesUndertaking} />
                      { formData?.noOutstandingDuesUndertaking&&<p className="small text-success">Uploaded :{formData?.noOutstandingDuesUndertaking?.fileName }</p>}
                {errors && errors.noOutstandingDuesUndertaking && (
                          <span className="text-danger small">{errors.noOutstandingDuesUndertaking}</span>
                        )}
                    </div>
                </div>
 
                <div className='d-flex border-bottom border-secondary '>
                    <h4 className='col-1'></h4>
                    <div className='d-flex gap-2 border-start border-end border-secondary '>
                        <h4 className='col-1 d-flex align-items-center justify-content-center border-end border-secondary'>11.</h4>
                        <p className='w-100 p-2'>સહાય અન્વયે બાંધકામ કરવાનું થતું હોય તો તે માટે ઉદ્યોગ અને ખાણ વિભાગના ઠરાવ ક્રમાંક : એસપીઓ-૧૦૨૦૦૫-૧૪૦૭-ચ, તા.૨૨/૧૧/૦૬ તથા વખતો વખતની જોગવાઇ  અન્વયે “ઇ” ટેન્ડરીંગ કરવામાં આવશે, અને તે અંગેની સૂચનાઓનું ચૂસ્તપણે પાલન કરવામાં આવશે, તે અંગેની લેખિત બાંહેધરી. સામેલ છે ? તેની નકલ (Construction and procurement will be done via “e-tendering” as per prevailing government rules and resolutions).*</p>
                    </div>
                    <div className='col-5 d-flex flex-column d-flex align-items-center justify-content-center'>
                        <input type="file" className="form-control w-75" onChange={(e)=>handleFileChange(e,"constructionProcurementETendering")} name="constructionProcurementETendering"   accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" id="uploadPlan" ref={refs.constructionProcurementETendering} />
                       { formData?.constructionProcurementETendering&&<p className="small text-success">Uploaded :{formData?.constructionProcurementETendering?.fileName }</p>}
                {errors && errors.constructionProcurementETendering && (
                          <span className="text-danger small">{errors.constructionProcurementETendering}</span>
                        )}
                    </div>
                </div>

                <div className='d-flex border-bottom border-secondary '>
                    <h4 className='col-1'></h4>
                    <div className='d-flex gap-2 border-start border-end border-secondary '>
                        <h4 className='col-1 d-flex align-items-center justify-content-center border-end border-secondary'>12.</h4>
                        <p className='w-100 p-2'>મંજૂર થયેલ સહાય અન્વયે જો કોઇપણ વસ્તુની ખરીદી કરવાની થતી હોય તો તે અંગે સરકારશ્રીના પ્રવર્તમાન ધારાધોરણો અને નિયમોનુસાર “ઇ” ટેન્ડરીંગથી કરવામાં આવશે, તે અંગેની લેખિત બાંહેધરી. સામેલ છે ? તેની નકલ (Goods purchased will follow government procurement rules and e-tendering procedures).*</p>
                    </div>
                    <div className='col-5 d-flex flex-column d-flex align-items-center justify-content-center'>
                        <input type="file" className="form-control w-75" onChange={(e)=>handleFileChange(e,"goodsProcurementETendering")} name="goodsProcurementETendering"   accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" id="uploadPlan" ref={refs.goodsProcurementETendering} />
                       { formData?.goodsProcurementETendering&&<p className="small text-success">Uploaded :{formData?.goodsProcurementETendering?.fileName }</p>}
                {errors && errors.goodsProcurementETendering && (
                          <span className="text-danger small">{errors.goodsProcurementETendering}</span>
                        )}
                    </div>
                </div>
 
                <div className='d-flex '>
                    <h4 className='col-1'></h4>
                    <div className='d-flex gap-2 border-start border-end border-secondary '>
                        <h4 className='col-1 d-flex align-items-center justify-content-center border-end border-secondary'>13.</h4>
                        <p className='w-100 p-2'>જે હેતુ માટે સહાય મંજુર થશે તે હેતુ માટે જ ઉપયોગ કરવામાં આવશે તેવી બાંહેધરી. (A guarantee that the assistance will be used solely for the approved purpose).*</p>
                    </div>
                    <div className='col-5 d-flex flex-column d-flex align-items-center justify-content-center'>
                        <input type="file" className="form-control w-75" onChange={(e)=>handleFileChange(e,"guaranteeAssistance")} name="guaranteeAssistance"   accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" id="uploadPlan" ref={refs.guaranteeAssistance} />
                       { formData?.guaranteeAssistance&&<p className="small text-success">Uploaded :{formData?.guaranteeAssistance?.fileName }</p>}
                {errors && errors.guaranteeAssistance && (
                          <span className="text-danger small">{errors.guaranteeAssistance}</span>
                        )}
                    </div>
                </div>
 
              </div>
            </div>
       
        <div className="d-flex justify-content-end gap-2 mb-3">
            <button className="btn btn-secondary" onClick={onBack}>Back</button>
            <button className="btn btn-info" onClick={handleNextClick}>Next</button>
        </div>
      </div>
    </>
  )
}
 
export default APMCp2